import clsx from 'clsx';
import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

export default function Persons({ blok }) {
  const styles = clsx('blok-persons flex text-center flex-wrap justify-center gap-12 mb-10');

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      {blok.blocks.map((block) => (
        <StoryblokComponent blok={block} key={block._uid} />
      ))}
    </div>
  );
}
